// src/App.js

import React, { useMemo } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';

// 导入布局组件
import MainLayout from './layouts/MainLayout';
import AuthLayout from './layouts/AuthLayout';


// 导入你的所有页面和组件
import Home from './pages/Home';
import Admin from './pages/Admin';
import NumsensePage from './pages/Numsense';
import PlannerPage from './pages/PlannerGatewayPage';
import GamesPage from './pages/Games';
import Terms from './pages/Terms';
import Privacy from './pages/Privacy';
import ActivationPage from './pages/ActivationPage';
import Profile from './pages/Profile';
import Assessment from './pages/Assessment';
import AnnouncementsPage from './pages/AnnouncementsPage';
import ForumPage from './pages/ForumPage';
import FileRepositoryPage from './pages/FileRepositoryPage';


import Register from './opencomponents/Register';
import NotFound from './pages/NotFound';
import LoginUser from './opencomponents/LoginUser';

function AppContent() {
    const { user, onLoginSuccess } = useAuth();
    
    // 导航项的定义保持不变
    const navigationItems = useMemo(() => {
        const baseItems = [
            { label: '游戏', path: '/games' },
            { label: '计划', path: '/planner' },
        ];
        if (user) {
            // 插入个人档案链接
            baseItems.push({ label: '档案', path: '/profile' });
        }
        if (user && (user.role === 'admin' || user.role === 'site_owner')) {
            baseItems.push({ label: '管理', path: '/admin' });
            baseItems.push({ label: '仓库', path: '/files' });
        }
        return baseItems;
    }, [user]);

    return (
        <Router>
            <Routes>
                {/* 路由组 1: 使用 MainLayout (有顶栏) */}
                <Route path="/" element={<MainLayout navItems={navigationItems} />}>
                    {/* 这些是 MainLayout 的子路由，它们会被渲染到 <Outlet /> 中 */}
                    <Route index element={<Home />} /> {/* index 表示这是 "/" 路径的默认子路由 */}
                    <Route path="admin" element={<Admin />} />
                    <Route path="planner" element={<PlannerPage />} />
                    <Route path="profile" element={<Profile />} />
                    <Route path="activate/:token" element={<ActivationPage />} />
                    <Route path="assessment" element={<Assessment />} />
                    <Route path="announcements" element={<AnnouncementsPage />} />
                    <Route path="forum" element={<ForumPage />}/>
                    <Route path="files" element={<FileRepositoryPage />}/>
                    
                    <Route path="games" element={<GamesPage />} />
                    <Route path="games/numsense" element={<NumsensePage />} />

                    <Route path="login" element={<LoginUser onLogin={onLoginSuccess} />} />
                    <Route path="register" element={<Register />} />
                </Route>

                {/* 路由组 2: 使用 AuthLayout (无顶栏, 居中) */}
                <Route element={<AuthLayout />}>
                    
                </Route>

                <Route path="/terms" element={<Terms />} />
                <Route path="/privacy" element={<Privacy />} />

                {/* 404 页面 */}
                <Route element={<MainLayout navItems={navigationItems} />}>
                    <Route path="*" element={<NotFound />} />
                </Route>
            </Routes>
        </Router>
    );
}

function App() {
    return (
        <AuthProvider>
            <AppContent />
        </AuthProvider>
    );
}

export default App;
